/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CancellationReasonEnum = {
    PatientNoShow: 'PATIENT_NO_SHOW',
    PatientSick: 'PATIENT_SICK',
    TherapistUnableToAttend: 'THERAPIST_UNABLE_TO_ATTEND',
    BookingError: 'BOOKING_ERROR',
    Other: 'OTHER',
    UnsuitableDate: 'UNSUITABLE_DATE',
    TherapyUncertainty: 'THERAPY_UNCERTAINTY',
    RelationUnsuitable: 'RELATION_UNSUITABLE',
    FinancialReasons: 'FINANCIAL_REASONS',
    TherapistSick: 'THERAPIST_SICK',
    OutstandingPayment: 'OUTSTANDING_PAYMENT',
    TestAppointment: 'TEST_APPOINTMENT',
    ConsultationReportUnavailable: 'CONSULTATION_REPORT_UNAVAILABLE',
    DunningProcessInitiated: 'DUNNING_PROCESS_INITIATED',
    ChangeOfTherapist: 'CHANGE_OF_THERAPIST',
    Unspecified: 'UNSPECIFIED',
    TherapyElsewhere: 'THERAPY_ELSEWHERE',
    FurtherAppointmentsNotNeeded: 'FURTHER_APPOINTMENTS_NOT_NEEDED'
} as const;
export type CancellationReasonEnum = typeof CancellationReasonEnum[keyof typeof CancellationReasonEnum];

